import * as AcceptNotification from '@ori-events/accept-notification';
import * as AcceptNotificationFailed from '@ori-events/accept-notification-failed';
import * as AddBackorderDemand from '@ori-events/add-backorder-demand';
import * as AddBackorderDemandFailed from '@ori-events/add-backorder-demand-failed';
import * as AddBasketOffer from '@ori-events/add-basket-offer';
import * as AddBasketOfferFailed from '@ori-events/add-basket-offer-failed';
import * as AddCatalogueOffer from '@ori-events/add-catalogue-offer';
import * as AddCatalogueOfferFailed from '@ori-events/add-catalogue-offer-failed';
import * as AddCustomerOrder from '@ori-events/add-customer-order';
import * as AddCustomerOrderFailed from '@ori-events/add-customer-order-failed';
import * as AddFreeShippingOffer from '@ori-events/add-free-shipping-offer';
import * as AddFreeShippingOfferFailed from '@ori-events/add-free-shipping-offer-failed';
import * as AddToBasket from '@ori-events/add-to-basket';
import * as AddToBasketFailed from '@ori-events/add-to-basket-failed';
import * as AddVoucher from '@ori-events/add-voucher';
import * as AddVoucherFailed from '@ori-events/add-voucher-failed';
import * as CancelBackorderDemand from '@ori-events/cancel-backorder-demand';
import * as CancelSubscription from '@ori-events/cancel-subscription';
import * as CancelSubscriptionFailed from '@ori-events/cancel-subscription-failed';
import * as ClearBasket from '@ori-events/clear-basket';
import * as DelaySubscription from '@ori-events/delay-subscription';
import * as DelaySubscriptionFailed from '@ori-events/delay-subscription-failed';
import * as DeleteOfferItem from '@ori-events/delete-offer-item';
import * as DeleteOfferItemFailed from '@ori-events/delete-offer-item-failed';
import * as RemoveBasketItem from '@ori-events/remove-basket-item';
import * as RemoveBasketItemFailed from '@ori-events/remove-basket-item-failed';
import * as RemoveCustomerOrder from '@ori-events/remove-customer-order';
import * as RemoveCustomerOrderFailed from '@ori-events/remove-customer-order-failed';
import * as RemoveShippingOfferItem from '@ori-events/remove-shipping-offer-item';
import * as RemoveShippingOfferItemFailed from '@ori-events/remove-shipping-offer-item-failed';
import * as RemoveVoucher from '@ori-events/remove-voucher';
import * as RemoveVoucherFailed from '@ori-events/remove-voucher-failed';
import * as ReplaceShoppingBagItem from '@ori-events/replace-shopping-bag-item';
import * as ReplaceShoppingBagItemFailed from '@ori-events/replace-shopping-bag-item-failed';
import * as ReplaceSubscription from '@ori-events/replace-subscription';
import * as ReplaceSubscriptionFailed from '@ori-events/replace-subscription-failed';
import * as RequestShoppingContext from '@ori-events/request-shopping-context';
import * as ResetShippingSelection from '@ori-events/reset-shipping-selection';
import * as ShoppingContextLoaded from '@ori-events/shopping-context-loaded';
import * as UpdateBasketItem from '@ori-events/update-basket-item';
import * as UpdateBasketItemFailed from '@ori-events/update-basket-item-failed';
import * as UpdateCustomerOrderItem from '@ori-events/update-customer-order-item';
import * as UpdateCustomerOrderItemFailed from '@ori-events/update-customer-order-item-failed';
import * as UpdateDelivery from '@ori-events/update-delivery';
import * as UpdateDeliveryChannel from '@ori-events/update-delivery-channel';
import * as UpdateDeliveryChannelFailed from '@ori-events/update-delivery-channel-failed';
import * as UpdateDeliveryFailed from '@ori-events/update-delivery-failed';
import * as UpdateDonation from '@ori-events/update-donation';
import * as UpdateDonationFailed from '@ori-events/update-donation-failed';
import * as UpdateOfferItem from '@ori-events/update-offer-item';
import * as UpdateOfferItemFailed from '@ori-events/update-offer-item-failed';
import * as UpdateOfferItems from '@ori-events/update-offer-items';
import * as UpdatePaymentProvider from '@ori-events/update-payment-provider';
import * as UpdatePaymentProviderFailed from '@ori-events/update-payment-provider-failed';

/** Name / type of event which can trigger an action on current shopping context (loading, modification). */

/** Failed response event name / type for actions triggered on shopping context. */

/**
 * Success response event name / type for actions triggered on shopping context.
 * The event data is the same BasketUpdated.Data format.
 */

/**
 * Configuration of 1 particular shopping context action. For now contains
 * just the success & failed events. Might contain the handler code reference
 * for particular action and similar in the future.
 */

/**
 * Configuration of shopping context actions. Mapping of triggering events to response
 * success & failed events.
 */
export const shoppingContextActions = new Map([[AcceptNotification.Name, {
  failedEvent: AcceptNotificationFailed.Name
}], [AddBackorderDemand.Name, {
  failedEvent: AddBackorderDemandFailed.Name
}], [AddBasketOffer.Name, {
  failedEvent: AddBasketOfferFailed.Name
}], [AddCatalogueOffer.Name, {
  failedEvent: AddCatalogueOfferFailed.Name
}], [AddCustomerOrder.Name, {
  failedEvent: AddCustomerOrderFailed.Name
}], [AddFreeShippingOffer.Name, {
  failedEvent: AddFreeShippingOfferFailed.Name
}], [AddToBasket.Name, {
  failedEvent: AddToBasketFailed.Name
}], [AddVoucher.Name, {
  failedEvent: AddVoucherFailed.Name
}], [CancelBackorderDemand.Name /* no failed event available so far */, {}], [CancelSubscription.Name, {
  failedEvent: CancelSubscriptionFailed.Name
}], [ClearBasket.Name /* no failed event available so far */, {}], [DelaySubscription.Name, {
  failedEvent: DelaySubscriptionFailed.Name
}], [DeleteOfferItem.Name, {
  failedEvent: DeleteOfferItemFailed.Name
}], [RemoveBasketItem.Name, {
  failedEvent: RemoveBasketItemFailed.Name
}], [RemoveCustomerOrder.Name, {
  failedEvent: RemoveCustomerOrderFailed.Name
}], [RemoveShippingOfferItem.Name, {
  failedEvent: RemoveShippingOfferItemFailed.Name
}], [RemoveVoucher.Name, {
  failedEvent: RemoveVoucherFailed.Name
}], [ReplaceShoppingBagItem.Name, {
  failedEvent: ReplaceShoppingBagItemFailed.Name
}], [ReplaceSubscription.Name, {
  failedEvent: ReplaceSubscriptionFailed.Name
}], [RequestShoppingContext.Name, {
  successEvent: ShoppingContextLoaded.Name
}], [ResetShippingSelection.Name /* no failed event available so far */, {}], [UpdateBasketItem.Name, {
  failedEvent: UpdateBasketItemFailed.Name
}], [UpdateCustomerOrderItem.Name, {
  failedEvent: UpdateCustomerOrderItemFailed.Name
}], [UpdateDelivery.Name, {
  failedEvent: UpdateDeliveryFailed.Name
}], [UpdateDeliveryChannel.Name, {
  failedEvent: UpdateDeliveryChannelFailed.Name
}], [UpdateDonation.Name, {
  failedEvent: UpdateDonationFailed.Name
}], [UpdateOfferItem.Name, {
  failedEvent: UpdateOfferItemFailed.Name
}], [UpdateOfferItems.Name /* no failed event available so far */, {}], [UpdatePaymentProvider.Name, {
  failedEvent: UpdatePaymentProviderFailed.Name
}]]);
//# sourceMappingURL=shoppingContextActions.js.map